import React, { useState, useRef, useEffect } from 'react';
import { Button, Select, Modal, Space, Tooltip, Upload, DatePicker, Input, message } from 'antd';
import ProTable, { ActionType } from '@ant-design/pro-table';
import axios from '../../../utils/AxiosUtil'

import { svrdCols } from '../../../constants/servedConstants'
import QueryBill from './svrdQuery.tsx';
import './proc.less'
import { SyncOutlined } from '@ant-design/icons'
import { axiosPostAndHint, mask, unmask } from '../../../components/reqAndHint'
import { sleep } from '../../../utils/TimeUtil'
import 'moment/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';
import { excel2Json } from '../../../utils/XlsxUtil';
import { log } from 'console';
import { useSelector } from 'react-redux'

// const { ActionType } = ProTable;
const { Option } = Select;


// 已处理列表
export default () => {
    const langValue = useSelector(state => state.langList.value)
    const actionRef = useRef<ActionType>();
    const { RangePicker } = DatePicker;
    let col = [...svrdCols];
    const [columns, setColumns] = useState(col);
    const [needSearchForm, setNeedSearchForm] = useState(true);//true表示搜索表单尚未动态加载

    const [modalVisible, setModalVisible] = useState(false);
    const [recordId, setRecordId] = useState();
    const [recordArea, setRecordArea] = useState();
    const [recordVolCnt, setRecordVolCnt] = useState();
    const [recordDate, setRecordDate] = useState();
    const [recordCount, setRecordCount] = useState();

    const [selectedRowKeysArr, setSelectedRowkeysArr] = useState([]);
    const [selectedRowArr, setSelectedRowArr] = useState([]);
    //areaList, dateList, statusList, operatorList
    const [areaList, setAreaList] = useState([])
    // const [dateList,setDateList] = useState([])
    const [operatorList, setOperatorList] = useState([])

    // 导入功能
    const handleUpload = async (file, billRecordId) => {
        // 票据代码
        let bill_index = null;

        Modal.confirm({
            title: '请输入票据代码：',
            content: <div>
                <Input
                    style={{ width: 250 }}
                    onChange={(e) => {
                        bill_index = e.target.value;
                        // console.log('bill_index:', bill_index);
                    }}
                ></Input>
            </div>,
            okText: '确定',
            cancelText: '取消',
            onOk: async () => {
                // console.log('bill_index:', bill_index);
                if (!bill_index) {
                    Modal.warning({ title: '请输入票据代码', okText: '知道了' });
                    return;
                }

                let json = await excel2Json(file, null);
                console.log('json:', json);
                console.log('isArr', Array.isArray(json));

                //只传给后台需要更新的序号和票据号码
                let bdJson = json.map((item, index) => {
                    return {
                        序号: item.序号,
                        票据号码: item.票据号码,
                        开票日期: item.开票日期,
                    }
                });
                // 获得用户名uname
                let uname = sessionStorage.getItem('uname');

                // axiosPostAndHint('/billmgt/importBillDetail', { bdJson, uname, billRecordId, bill_index },
                //     () => { actionRef.current?.reload() },
                //     () => { },
                //     120000);

                let data = await axios.post('/fund/billmgt/importBillDetail', { bdJson, uname, billRecordId, bill_index });
                // console.log('importBillDetail:', data?.data);
                if (data ?.data) {
                    let hintArr = data.data ?.hintArr;
                    Modal.info({
                        width: '30%',
                        title: data ?.data ?.msg,
                        content: (
                            <div style={{ fontSize: 16 }}>
                                {hintArr && hintArr.length > 0 && hintArr.map((h, i) => {
                                    return (<div key={i} style={{ marginTop: 7, marginBottom: 7 }}>{(i + 1) + '. ' + h}</div>)
                                })}
                            </div>
                        ),
                        onOk: () => { actionRef.current ?.reload() },
                        okText: '确定'
                    })
                } else {
                    Modal.error({
                        title: '导入失败',
                    })
                }

            },
            onCancel: () => { return false }
        })

    }



    // col.push(operCol);

    let winHeight;//窗口宽度，用于明细弹窗
    if (window.innerHeight) {
        winHeight = window.innerHeight;
    } else if ((document.body) && (document.body.clientHeight)) {
        winHeight = document.body.clientHeight;
    }

    //生成
    const batchConvert = () => {
        let areaSet = new Set();
        selectedRowArr.forEach(r => areaSet.add(r['地区']));
        if (areaSet.size > 1) {
            Modal.error({
                title: langValue == 0 ? '只能选同一地区的数据Only data from the same region can be selected' : (langValue == 1 ? '只能选同一地区的数据' : 'Only data from the same region can be selected'),
                content: langValue == 0 ? <>现含{areaSet.size}个地区,请重新选择<br />There are currently {areaSet.size} regions included, please choose again</> :
                    (langValue == 1 ? `现含${areaSet.size}个地区,请重新选择` : `There are currently ${areaSet.size} regions included, please choose again`)
            });
        }
        //批量生成xls并 下载
    }

    useEffect(() => {
        return () => {
            // setNeedSearchForm(true);
        }
    }, [])
    // 中英文切换
    const getColumns = (col) => {

        let operCol = {
            title: '操作',
            en_title: 'Operation',
            ch_title: '操作',
            valueType: 'option',
            render: (text, record, _, action) => {
                return [
                    <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 'normal' }} key='handle'>
                        <Button
                            type="link"
                            key="query"
                            onClick={() => {
                                setModalVisible(true);
                                // setRecordId(record.recordId);
                                setRecordId(record.bill_record_id);
                                setRecordArea(record['地区']);
                                setRecordVolCnt(record['志工人数']);
                                setRecordDate(record['生成日期']);
                                setRecordCount(record['开立票据份数']);
                            }}
                        >
                            {langValue == 0 ? '查看View' : (langValue == 1 ? "查看" : 'View')}
                        </Button>
                        {/* <Upload
                            key='upload'
                            beforeUpload={(file) => {
                                handleUpload(file, record.bill_record_id);
                                return false; // 取消组件本身的上传动作
                            }}
                            showUploadList={false}
                            data={record} //对应后台parse函数fields
                            maxCount={1}
                        >
                            <Button
                            // disabled={record['导入状态'] == '已导入'}
                            >
                                {langValue==0?'导入Import':(langValue==1?"导入":'Import')}
                            </Button>
                        </Upload > */}
                    </div>
                ];
            }
        };

        //审核状态筛选组件
        // col.map((c, i) => {
        //     if ((i != 1) && (i != 4) && (i != 7) && (i != 5)) {
        //         c.renderFormItem = () => { return null };
        //     }
        // });
        let newCol = [...col];
        newCol.push(operCol)
        newCol.forEach((c, i) => {
            if (i == 1) {
                c.renderFormItem = () => {
                    return <RangePicker
                        locale={locale}
                        format="YYYY-MM-DD"
                        placeholder={langValue == 0 ? ['开始日期Start Date', '结束日期End Date'] : (langValue == 1 ? ['开始日期', '结束日期'] : ['Start Date', 'End Date'])}
                    />
                };
            }
            else if (i == 4) {
                c.renderFormItem = () => {
                    return <Select defaultValue="" style={{ width: 300 }} showSearch>
                        <Option key="allarea" value="">{langValue == 0 ? '所有地区All Regions' : (langValue == 1 ? '所有地区' : 'All Regions')}</Option>
                        {areaList.map((area, i) => {
                            return <Option key={area} value={area}>{area}</Option>
                        })}
                    </Select>
                };
            }
            else if (i == 5) {
                c.renderFormItem = () => {
                    return <Select defaultValue="" style={{ width: 200 }} showSearch>
                        <Option key="allOperator" value="">{langValue == 0 ? '所有操作人员All Operators' : (langValue == 1 ? '所有操作人员' : 'All Operators')}</Option>
                        {operatorList.map((o, i) => {
                            return <Option key={o} value={o}>{o}</Option>
                        })}
                    </Select>
                };
            }
            else if (i == 7) {
                // c.renderFormItem=() => {
                //     return <Select defaultValue="" >
                //         <Option key="all" value="">{langValue==0?'所有状态All Status':(langValue==1?'所有状态':'All Status')}</Option>
                //         <Option key="unuploaded" value="未导入">{langValue==0?'未导入Not Imported':(langValue==1?'未导入':'Not Imported')}</Option>
                //         <Option key="uploaded" value="已导入">{langValue==0?'已导入Imported':(langValue==1?'已导入':'Imported')}</Option>
                //     </Select>
                // }
                // c.render = (_,item)=>{
                //     return langValue==0?<span>{item.ch_status}<br/>{item.en_status}</span>:(langValue==1?item.ch_status:item.en_status)
                // }
            } else {
                c.renderFormItem = () => {
                    return null
                }
            }
            c.title = langValue == 0 ? <>{c.ch_title}<br />{c.en_title}</> : (langValue == 1 ? c.ch_title : c.en_title)
        })
        return newCol;

    }

    return (
        <div className='proc-wrapper' id='server-billmgt'>
            <ProTable
                sticky
                columns={getColumns(columns)}
                actionRef={actionRef}
                cardBordered
                // rowSelection={rowSelection}
                // toolBarRender={false}
                //工具栏选项
                options={{
                    density: true,
                    fullScreen: true,
                    reload: false,
                    setting: false,
                }}
                request={async (
                    // 第一个参数 params 查询表单和 params 参数的结合
                    // 第一个参数中一定会有 pageSize 和  current ，这两个参数是 antd 的规范
                    params: {
                        pageSize: number;
                        current: number;
                    },
                    sort,
                    filter,
                ) => {
                    // 这里需要返回一个 Promise,在返回之前你可以进行数据转化
                    // 如果需要转化参数可以在这里进行修改
                    // console.log('pro table params:', params, ' sort:', sort, ' filter:', filter);
                    const coverParams = (params) => {
                        let p = { ...params, uid: sessionStorage.getItem('uid') };
                        // console.log('coverParams:', p);
                        return p;
                    }

                    const data = await axios.post('/fund/billmgt/served-list', coverParams(params));
                    const { billRecordList, statusList, } = data.data;
                    // console.log("bill record list data:", data.data);
                    let dataSrc = [...billRecordList];
                    const statusObj = {
                        '已导入': 'Imported',
                        '未导入': 'Not Imported'
                    }
                    dataSrc.forEach((d, i) => {
                        d['序号'] = i + 1;
                        d.key = i + 1;
                        // d.ch_status = d['导入状态']
                        // d.en_status = statusObj[d.ch_status]
                    });
                    if (data.data.areaList && data.data.areaList.length) {
                        setAreaList(data.data.areaList)
                    }
                    if (data.data.operatorList && data.data.operatorList.length) {
                        setOperatorList(data.data.operatorList)
                    }
                    // if (needSearchForm) {
                    //     //动态搜索表单，只在首次交互加载
                    //     let col = [...columns.slice()];
                    //     if (dateList && dateList.length) {
                    //         // console.log("new datelist new render");
                    //         col[1].renderFormItem = () => {
                    //             return <RangePicker
                    //                 locale={locale}
                    //                 format="YYYY-MM-DD"
                    //                 placeholder={langValue==0?['开始日期Start Date', '结束日期End Date']:(langValue==1?['开始日期', '结束日期']:['Start Date', 'End Date'])}
                    //             />
                    //         };
                    //     } else {
                    //         // console.log("no datelist no render");
                    //         col[1].renderFormItem = () => {
                    //             return false;
                    //         };
                    //     }
                    //     if (areaList && areaList.length) {
                    //         // console.log('col[4]:', col[4]);

                    //         col[4].renderFormItem = () => {
                    //             return <Select defaultValue="" style={{ width: 300 }} showSearch>
                    //                 <Option key="allarea" value="">{langValue==0?'所有地区All Regions':(langValue==1?'所有地区':'All Regions')}</Option>
                    //                 {areaList.map((area, i) => {
                    //                     return <Option key={area} value={area}>{area}</Option>
                    //                 })}
                    //             </Select>
                    //         };
                    //     } else {
                    //         col[4].renderFormItem = () => {
                    //             return false;
                    //         };
                    //     }

                    //     // 操作人员筛选框
                    //     if (operatorList && operatorList.length) {

                    //         // console.log('operatorList', operatorList);
                    //         // console.log('col[5]', col[5]);

                    //         col[5].renderFormItem = () => {
                    //             return <Select defaultValue="" style={{ width: 200 }} showSearch>
                    //                 <Option key="allOperator" value="">{langValue==0?'所有操作人员All Operators':(langValue==1?'所有操作人员':'All Operators')}</Option>
                    //                 {operatorList.map((o, i) => {
                    //                     return <Option key={o} value={o}>{o}</Option>
                    //                 })}
                    //             </Select>
                    //         };
                    //     } else {
                    //         col[5].renderFormItem = () => {
                    //             return false;
                    //         };
                    //     }

                    //     // setNeedSearchForm(false);
                    //     setColumns([...col]);
                    //     await sleep(200);//有时首次动态更新搜索表单不成功，貌似col和data经过了某种计算
                    //     // console.log('*****after sleep*****');
                    // }

                    return {
                        data: dataSrc,
                        // success 请返回 true，
                        // 不然 table 会停止解析数据，即使有数据
                        success: true,
                        // 不传会使用 data 的长度，如果是分页一定要传
                        total: dataSrc.length,
                    };
                }}
                editable={{
                    type: 'multiple',
                }}
                columnsState={{
                    persistenceKey: 'pro-table-singe-demos',
                    persistenceType: 'sessionStorage',
                }}
                rowKey="序号"
                search={{
                    labelWidth: 'auto',
                    span: '5',
                    collapseRender: false,
                    searchText: langValue == 0 ? '查询Query' : (langValue == 1 ? '查询' : 'Query'),
                    resetText: langValue == 0 ? '重置Reset' : (langValue == 1 ? '重置' : 'Reset'),
                }}
                pagination={{
                    pageSize: 10,
                    pageSizeOptions: [10, 20, 50, 100, 1000],
                    showQuickJumper: true,
                    showSizeChanger: true,

                }}
                dateFormatter="string"
                headerTitle={langValue == 0 ? "已处理列表 Ticket List" : (langValue == 1 ? "已处理列表" : 'Ticket List')}
                tableAlertRender={({ selectedRowKeys, selectedRows, onCleanSelected }) => (
                    <Space size={24}>
                        <span>
                            {langValue == 0 ? `已选${selectedRowKeys.length}项 Selected ${selectedRowKeys.length} items` : (langValue == 1 ? `已选${selectedRowKeys.length}项` : `Selected ${selectedRowKeys.length} items`)}
                            {selectedRowKeys.length ? (<a style={{ marginLeft: 8 }} onClick={onCleanSelected}>
                                {langValue == 0 ? '取消选择Unselected' : (langValue == 1 ? '取消选择' : 'Unselected')}
                            </a>) : null}
                        </span>
                    </Space>
                )}
                tableAlertOptionRender={() => {
                    let empty = !selectedRowKeysArr.length;
                    let Btn = <Button type='primary' icon={<SyncOutlined spin={false} />}
                        disabled={empty}
                        onClick={batchConvert}>{langValue == 0 ? '生成Generate' : (langValue == 1 ? '生成' : 'Generate')}</Button>;
                    return empty ? (
                        <Tooltip title="请先勾选记录">
                            {Btn}
                        </Tooltip>
                    ) : Btn;
                }}
                onRequestError={(error) => {
                    error = typeof error == 'object' ? JSON.stringify(error) : error;
                    Modal.error({ title: '表格加载错误' });
                }}
            />
            {/* 明细页面弹窗 */}
            <Modal
                centered
                visible={modalVisible}
                onOk={() => setModalVisible(false)}
                onCancel={() => setModalVisible(false)}
                width={'100%'}
                footer={false}
                bodyStyle={{ minHeight: winHeight }}
                destroyOnClose={true}//关闭时清空（重新加载子组件）
                maskClosable={false}//点击遮罩不关闭
                closable={false}//不显示右上角的关闭按钮（X)
            >
                <QueryBill recordId={recordId}
                    recordArea={recordArea}
                    recordVolCnt={recordVolCnt}
                    recordDate={recordDate}
                    recordCount={recordCount}
                    setModalVisible={setModalVisible}
                    reloadParent={() => {
                        setModalVisible(false);
                        actionRef.current.reload();
                    }}
                />
            </Modal>

        </div>
    );
};     